import { useEffect, useState } from "react";

const STORAGE_KEY = "biten_theme";
const THEME_EVENT = "biten-theme-change";

export function getTheme() {
  return localStorage.getItem(STORAGE_KEY) === "light" ? "light" : "dark";
}

export function applyTheme(theme) {
  document.documentElement.dataset.theme = theme;
  localStorage.setItem(STORAGE_KEY, theme);
  window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: theme }));
}

// Set the attribute before first paint so there is no dark→light flash.
export function initTheme() {
  document.documentElement.dataset.theme = getTheme();
}

export function useTheme() {
  const [theme, setTheme] = useState(getTheme);

  useEffect(() => {
    const onChange = (e) => setTheme(e.detail);
    window.addEventListener(THEME_EVENT, onChange);
    return () => window.removeEventListener(THEME_EVENT, onChange);
  }, []);

  const toggleTheme = () => applyTheme(getTheme() === "light" ? "dark" : "light");

  return { theme, toggleTheme };
}
